import { useEffect, useState } from "react"

const useScrollPosition = (scrollableElement?: HTMLElement | null) => {
  const [scrollPosition, setScrollPosition] = useState(0)

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(scrollableElement?.scrollTop || 0)
    }
    updatePosition()
    const listenerElement =
      scrollableElement === document.documentElement
        ? document
        : scrollableElement
    listenerElement?.addEventListener("scroll", updatePosition)
    return () => {
      listenerElement?.removeEventListener("scroll", updatePosition)
    }
  }, [scrollableElement])

  return scrollPosition
}

export default useScrollPosition
